import { DemandValidationError, IDemandValidationError } from '../validation/types/IDemandValidationError';
import { I18nService } from '@lib/i18n';

export interface IDemandAnnounceResult {
    demandId: string;
    error?: IDemandValidationError;
}

export class DemandAnnounceResult {
    public readonly demandId: string;
    public readonly error?: DemandValidationError;

    constructor(dto: IDemandAnnounceResult, i18n: I18nService) {
        this.demandId = dto.demandId;
        if (dto.error) {
            this.error = new DemandValidationError(dto.error, i18n);
        }
    }
}
